<template>
    <div class="side-center">
        <div class="side">
            <ul>
                <router-link :to="{name: 'ice-cream'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Мороженое</span></a></router-link>

                <router-link :to="{name: 'homey'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>По&#8209;домашнему с&nbsp;Кубани</span></a></router-link>

                <router-link :to="{name: 'cheesecakes'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Сырки</span></a></router-link>


                <router-link :to="{name: 'chezbi'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Чизби</span></a></router-link>

                <router-link :to="{name: 'chocolate'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Шоколад</span></a></router-link>

                <router-link :to="{name: 'molonez'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Молонез</span></a></router-link>

<!--                
                <router-link :to="{name: 'risovashki'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Рисовашки</span></a></router-link>
-->
                <router-link :to="{name: 'condensed-milk'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Сгущеное молоко</span></a></router-link>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SideCenter"
    }
</script>